
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const Disclaimer = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 mb-8 transition-colors min-h-[48px] touch-manipulation"
        >
          <ArrowLeft size={16} />
          Back to Home
        </Link>
        
        <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-8">Legal Disclaimer — Agent & Supplier Use</h1>
        
        <div className="bg-white rounded-lg shadow-sm p-6 sm:p-8">
          <p className="text-sm text-gray-500 mb-6">Updated: July 2025</p>
          
          <p className="text-gray-700 mb-6 leading-relaxed">
            ZimKonnect is a facilitator platform only. We connect diaspora users with local agents and suppliers. However:
          </p>

          <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-6">
            <li>We do not control or directly manage any projects</li>
            <li>All agents and suppliers operate independently</li>
            <li>Users must conduct their own due diligence</li>
          </ul>

          <div className="space-y-6">
            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-3 flex items-center">
                <span className="mr-2">🛡</span> Verification Process
              </h2>
              <p className="text-gray-700">
                While ZimKonnect verifies agents and suppliers, we cannot guarantee workmanship, timelines, or pricing outcomes.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-3 flex items-center">
                <span className="mr-2">🧾</span> Financial Liability
              </h2>
              <p className="text-gray-700 mb-3">ZimKonnect is not liable for:</p>
              <ul className="list-disc pl-6 text-gray-700 space-y-1">
                <li>Missed deadlines</li>
                <li>Cost overruns</li>
                <li>Materials quality</li>
                <li>Legal disputes between users and third parties</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-3 flex items-center">
                <span className="mr-2">✅</span> Your Responsibility
              </h2>
              <p className="text-gray-700">
                By using ZimKonnect, you accept responsibility for choosing who you assign and engage with.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;
